import React from 'react';
import { ShieldCheck } from 'lucide-react';

export const TransparencyNotice = () => (
  <div className="bg-[#ECFDF5] border border-[#A7F3D0] rounded-lg p-4 my-4" data-testid="transparency-notice">
    <div className="flex items-start gap-3">
      <ShieldCheck className="w-5 h-5 text-[#059669] mt-0.5 flex-shrink-0" />
      <div>
        <h4 className="text-sm font-bold text-[#064E3B] mb-1.5">IRS-Recognized 501(c)(3) Public Charity</h4>
        <p className="text-xs text-[#065F46] leading-relaxed">
          Novena Humanitarian Foundation, Inc. is officially recognized by the IRS as a 501(c)(3) public charity
          (EIN 41-4097072, effective February 2, 2026). <strong>Contributions are tax-deductible to the extent permitted by law.</strong>
        </p>
        <p className="text-xs text-[#065F46] leading-relaxed mt-2">
          We remain committed to full transparency. Thank you for supporting our mission and helping us build lasting impact.
        </p>
      </div>
    </div>
  </div>
);

export const TransparencyCheckbox = ({ checked, onChange }) => (
  <label className="flex items-start gap-2.5 cursor-pointer mt-3" data-testid="transparency-checkbox-label">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="accent-[#BA1826] mt-0.5 flex-shrink-0"
      data-testid="transparency-checkbox"
    />
    <span className="text-[11px] text-[#4B5563] leading-relaxed">
      I confirm that I am making this contribution to an IRS-recognized 501(c)(3) public charity.
    </span>
  </label>
);
